import React from 'react';

import { CustomsInstructionEditDisplay } from '@components/utilities/Bookings/CustomsInstructionEditDisplay';
import { useSearch } from '@hooks/next/useSearch';
import { url } from '@utils/pages';
import { useHistory } from 'react-router-dom';
import { z } from 'zod';

export const CustomsInstruction: React.FC = () => {
  const {
    search: { from, d2dNo },
  } = useSearch(
    z.object({
      from: z.string().nullish(),
      d2dNo: z.string(),
    }),
  );

  const history = useHistory();

  return (
    <CustomsInstructionEditDisplay
      d2dNo={d2dNo}
      onGoBack={() =>
        history.push(from ?? `${url('/utilities/Bookings/CurrentBookingDetails')}?d2dNo=${d2dNo}`)
      }
    />
  );
};
